import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Radio, Tooltip } from 'antd';

const AntRadioGroup = Radio.Group;

export default class RadioGroup extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    valueKey: 'value',
    labelKey: 'label',
  };

  handleBlur = () => {
    const { onBlur, value } = this.props;
    if (onBlur) {
      onBlur(value);
    }
  };

  render() {
    const { valueKey, labelKey, options, tooltips, ...restProps } = this.props;

    return (
      <AntRadioGroup {...restProps} onBlur={this.handleBlur}>
        {options.map(({ [valueKey]: valueOption, [labelKey]: label }, key) => {
          return (
            <Radio key={key} value={valueOption}>
              {label}&nbsp;
              {options[key].tooltip && (
                <Tooltip title={options[key].tooltip}>
                  <QuestionCircleOutlined />
                </Tooltip>
              )}
            </Radio>
          );
        })}
      </AntRadioGroup>
    );
  }
}
